import { Component } from '@angular/core';
import { AlertController, NavController, NavParams } from 'ionic-angular';
import { SuperTabsController } from "../../components/ionic2-super-tabs/src";
import {XpWorkorderService} from "../../services/xp-workorder.service";
import {TranslateService} from "@ngx-translate/core";

@Component({
  selector: 'page-xp-unit-overview',
  templateUrl: 'xp-unit-overview.html'
})
export class XpUnitOverviewPage {

  unit:any;

  constructor(
      public navCtrl: NavController,
      public navParams: NavParams,
      public alertCtrl: AlertController,
      public workorderService: XpWorkorderService,
      public translate: TranslateService,
      public superTabsCtrl: SuperTabsController
  ) {
    this.unit = navParams.get('unit');
  }

  getUnitStatusText(status){
    switch(parseInt(status)){
      case 1:
        return 'Actief';
      case 9:
        return 'Gerecycleerd'
      case -1:
        return 'Verborgen';
    }
    return 'Actief';
  }

  public chooseNewWorkorderType(){
    let buttons = [];
    buttons.push({
      text: this.translate.instant('1e inbedrijfstelling'),
      handler: () => {
        this.goToNewWorkorder('1');
      }
    });
    buttons.push({
      text: this.translate.instant('Onderhoud'),
      handler: () => {
        this.goToNewWorkorder('2');
      }
    });
    buttons.push({
      text: this.translate.instant('Storing'),
      handler: () => {
        this.goToNewWorkorder('3');
      }
    });
    buttons.push({
      text: this.translate.instant('Buiten bedrijf stellen'),
      handler: () => {
        this.goToNewWorkorder('7');
      }
    });
    buttons.push({
      text: this.translate.instant('Meer...'),
      handler: () => {
        this.chooseNewWorkorderType2();
      }
    });
    this.alertCtrl.create({
      title: this.translate.instant('Type werkorder'),
      cssClass: 'alert-not-bold',
      buttons: buttons
    }).present();
  }

  public chooseNewWorkorderType2(){
    let buttons = [];
    buttons.push({
      text: this.translate.instant('Toestel verwijderen'),
      handler: () => {
        this.goToNewWorkorder('4');
      }
    });
    buttons.push({
      text: this.translate.instant('Garantiekaart invullen'),
      handler: () => {
        this.goToNewWorkorder('6');
      }
    });
    this.alertCtrl.create({
      title: this.translate.instant('Type werkorder'),
      cssClass: 'alert-not-bold',
      buttons: buttons
    }).present();
  }

  public goToNewWorkorder(workorder_type){
    this.workorderService.setDummyData(workorder_type).then(() => {
      this.alertCtrl.create({
        title: this.translate.instant('Werkorder toegevoegd'),
        message: this.translate.instant("De werkorder is toegevoegd. Ga naar 'Werkorders' om de nieuwe werkorder te openen."),
        buttons: [{
          text: this.translate.instant("Ga naar 'Werkorders'"),
          handler: () => {
            let tabs = this.navCtrl.parent.parent.parent;
            tabs.select(1);
          }
        }]
      }).present();
    });
  }

}



// WEBPACK FOOTER //
// ./src/pages/xp-unit-overview/xp-unit-overview.ts